import { registryFormIdFromSlotId } from '@/common/utils/registryFormIdFromSlotId'

/**
 * Id формы для реестра элементов GlobalProvider (registerElement.formId) и refillElementViaControls.
 */
export function resolveElementRegistryFormId(
  pageData: Record<string, any> | null | undefined,
  pagesDataSlotFid: string,
): string {
  const slot = String(pagesDataSlotFid ?? '').trim()
  const slotBase = registryFormIdFromSlotId(slot)

  const tryPrimitive = (v: unknown): string | null => {
    if (v == null) return null
    if (typeof v === 'number' && Number.isFinite(v)) return String(v)
    if (typeof v === 'boolean') return v ? '1' : '0'
    if (typeof v === 'string') {
      const t = v.trim()
      if (!t) return null
      if (t.startsWith('[object')) return null
      if (t.includes('typeId:') || t.includes('document:') || t.includes('view:')) {
        const match = t.match(/(?:^|[\s,(;])(?:fid|id)\s*:\s*['"]?([^'",)\s]+)['"]?/i)
        return match?.[1]?.trim() || null
      }
      return t
    }
    if (typeof v === 'object' && !Array.isArray(v)) {
      const o = v as Record<string, unknown>
      for (const candidate of [o.fid, o.id, o._id, o._text, o.value, o.formId, o.view, o.document]) {
        const extracted = tryPrimitive(candidate)
        if (extracted) return extracted
      }
    }
    return null
  }

  if (!pageData || typeof pageData !== 'object') {
    return slotBase || slot || ''
  }

  const schemaCandidates: unknown[] = [
    pageData.jsResult?.form_id,
    pageData.form?.form?._attributes?.id,
    pageData.form?._attributes?.id,
  ]
  const resolvedSchemaCandidates = schemaCandidates
    .map((candidate) => tryPrimitive(candidate))
    .filter((candidate): candidate is string => Boolean(candidate))
  // Приоритет: id экземпляра формы
  const instanceCandidates: unknown[] = [
    pageData.status,
    pageData.$fid,
    pageData.form?.form?._attributes?.fid,
    pageData.form?._attributes?.fid,
  ]

  for (const c of instanceCandidates) {
    const s = tryPrimitive(c)
    if (!s) continue
    if (slot && (s === slot || s === slotBase)) {
      const schemaFallback = resolvedSchemaCandidates.find(
        (candidate) => candidate !== slot && candidate !== slotBase,
      )
      if (schemaFallback) {
        return schemaFallback
      }
    }
    return s
  }

  const softCandidates: unknown[] = [
    pageData.formId,
  ]

  for (const c of softCandidates) {
    const s = tryPrimitive(c)
    if (s) return s
  }

  const raw = pageData.formId
  const nestedFormId = tryPrimitive(raw)
  if (nestedFormId) return nestedFormId

  for (const c of schemaCandidates) {
    const s = tryPrimitive(c)
    if (s) return s
  }

  return slotBase || slot || ''
}
